import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProductDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, NestedProductDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.NESTED_PRODUCTS,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'nested-products-with-join', id: 'GET-JOIN' },
            { type: 'nested-products', id: 'GET' },
        ],
    });
